var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseDialog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.98438 1.76562L2.125 0.867188L0.328125 2.625L1.22656 3.52344L7.20312 9.5L1.22656 15.5156L0.328125 16.375L2.125 18.1719L2.98438 17.2734L9 11.2969L14.9766 17.2734L15.875 18.1719L17.6328 16.375L16.7344 15.5156L10.7578 9.5L16.7344 3.52344L17.6328 2.625L15.875 0.867188L14.9766 1.76562L9 7.74219L2.98438 1.76562Z",
    fill: "#98BCD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDialog);
export default __webpack_public_path__ + "static/media/close_dialog.897486ddf99da9e0e3b01aecd653f55a.svg";
export { ForwardRef as ReactComponent };